import { NgModule } from '@angular/core';
 
 
import { APP_INITIALIZER } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
 
import { IonicPageModule } from 'ionic-angular';

import { HeaderComponent } from '../../components/headercomponent/headercomponent';
@NgModule({
    declarations: [HeaderComponent],

    exports: [
      HeaderComponent
    ],
    imports: [IonicModule
      //IonicModule.forRoot(HeaderComponent)
  ],
 
})
export class HeadercomponentModule {}

 


// WEBPACK FOOTER //
// ./src/components/headercomponent/headercomponent.module.ts